package org.chiangmeng.qfast.database

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class QueueHistoryQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectHistoryByShopId(shop_id: String, mapper: (
    id: Long,
    shop_id: String,
    ticket_number: Long,
    served_at: Long,
  ) -> T): Query<T> = SelectHistoryByShopIdQuery(shop_id) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1)!!,
      cursor.getLong(2)!!,
      cursor.getLong(3)!!
    )
  }

  public fun selectHistoryByShopId(shop_id: String): Query<QueueHistoryEntity> =
      selectHistoryByShopId(shop_id) { id, shop_id_, ticket_number, served_at ->
    QueueHistoryEntity(
      id,
      shop_id_,
      ticket_number,
      served_at
    )
  }

  public fun insertHistory(
    shop_id: String,
    ticket_number: Long,
    served_at: Long,
  ) {
    driver.execute(-1_869_285_591,
        """INSERT INTO QueueHistoryEntity (shop_id, ticket_number, served_at) VALUES (?, ?, ?)""",
        3) {
          bindString(0, shop_id)
          bindLong(1, ticket_number)
          bindLong(2, served_at)
        }
    notifyQueries(-1_869_285_591) { emit ->
      emit("QueueHistoryEntity")
    }
  }

  private inner class SelectHistoryByShopIdQuery<out T : Any>(
    public val shop_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("QueueHistoryEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("QueueHistoryEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-557_868_146,
        """SELECT QueueHistoryEntity.id, QueueHistoryEntity.shop_id, QueueHistoryEntity.ticket_number, QueueHistoryEntity.served_at FROM QueueHistoryEntity WHERE shop_id = ?""",
        mapper, 1) {
      bindString(0, shop_id)
    }

    override fun toString(): String = "QueueHistory.sq:selectHistoryByShopId"
  }
}
